import * as DeviceDetector from "device-detector";
import { UAParser } from "ua-parser-js";

export enum DeviceType {
  DESKTOP = "pc",
  TABLET = "tablet",
  MOBILE = "mobile",
  PHONE = "phone",
}

export function DetectDevice(): DeviceType {
  const info = DeviceDetector.parse();

  switch (info.type) {
    case "Mobile":
      return DeviceType.PHONE;
    case "Tablet":
      return DeviceType.TABLET;
    default:
      return DeviceType.DESKTOP;
  }
}

export const isNotPc = () => DetectDeviceUAParser() !== DeviceType.DESKTOP;
export const isMobile = () => DetectDeviceUAParser() === DeviceType.MOBILE || DetectDeviceUAParser() === DeviceType.PHONE;
export const isTablet = () => DetectDeviceUAParser() === DeviceType.TABLET;

// experiment (for 2 weeks https://arkadiumarena.visualstudio.com/Arena/_workitems/edit/54500)
export function DetectDeviceUAParser(): string {
  const parser = new UAParser();
  const deviceInfo = parser.getDevice();
  return deviceInfo.type || "pc";
}
